import { FormControl, FormGroup, Validators } from "@angular/forms";

export class ModalCheckConditionUseFormGroup extends FormGroup {
    constructor(requiredDocs: { cgu: boolean; cggc: boolean; pc: boolean }) {
    super({
      checkbox1: new FormControl({ value: false, disabled: !requiredDocs.cgu }, requiredDocs.cgu ? Validators.requiredTrue : []),
      checkbox2: new FormControl({ value: false, disabled: !requiredDocs.cggc }, requiredDocs.cggc ? Validators.requiredTrue : []),
      checkbox3: new FormControl({ value: false, disabled: !requiredDocs.pc }, requiredDocs.pc ? Validators.requiredTrue : []),
    });
  }
}